import qs from 'qs';
import { AxiosInstance } from 'axios';
import { OffsetPaginationInput } from '@app/data/inputs';
import { CollectionResource } from '@app/data/resources';
import {
    CreateTaskMessageTemplateInput,
    HydratedTaskMessageTemplateFilterInput,
    TaskMessageTemplateFilterInput,
    UpdateTaskMessageTemplateInput,
} from './inputs';
import { TaskMessageTemplateRef } from './refs';
import {
    HydratedTaskMessageTemplateResource,
    TaskMessageTemplateListItemResource,
    TaskMessageTemplateResource,
} from './resources';

export default class TaskMessageTemplate {
    private basePath = '/api/task-message-template';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get task message list
    get = async (
        pagination: OffsetPaginationInput,
        filter?: TaskMessageTemplateFilterInput,
    ): Promise<CollectionResource<TaskMessageTemplateListItemResource, {}>> => {
        const query = qs.stringify({ ...pagination, ...(filter || {}) });

        const { data } = await this.http.get(`${this.basePath}/?${query}`);

        return data;
    };

    // Get single task message template
    getById = async (id: ID): Promise<TaskMessageTemplateResource> => {
        const { data } = await this.http.get(`${this.basePath}/${id}`);

        return data;
    };

    // Create new task message template
    create = async (input: CreateTaskMessageTemplateInput): Promise<TaskMessageTemplateRef> => {
        const { data } = await this.http.post(`${this.basePath}/`, input);

        return data;
    };

    // Update task message template
    update = async (id: ID, input: UpdateTaskMessageTemplateInput): Promise<TaskMessageTemplateRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}`, input);

        return data;
    };

    // Archive task message template
    archive = async (id: ID): Promise<TaskMessageTemplateRef> => {
        const { data } = await this.http.delete(`${this.basePath}/${id}`);

        return data;
    };

    // Restore archived task message template
    restore = async (id: ID): Promise<TaskMessageTemplateRef> => {
        const { data } = await this.http.post(`${this.basePath}/${id}/restore`);

        return data;
    };

    // Fetches hydrated task message template
    getHydrated = async (
        id: ID,
        filter: HydratedTaskMessageTemplateFilterInput,
    ): Promise<HydratedTaskMessageTemplateResource> => {
        const query = qs.stringify(filter);
        const { data } = await this.http.get(`${this.basePath}/${id}/hydrated?${query}`);
        return data;
    };
}
